module.exports = __webpack_public_path__ + "img/B5 (1).59025b1d.svg";